import { useMutation } from "@tanstack/react-query";
import { getAuthApiClient } from "@shared/apis/sidekick/api-factories";

type Params = {
  code: string;
  codeVerifier: string;
};

export const useAdminImpersonateCodeExchange = () => {
  const api = getAuthApiClient();

  return useMutation({
    mutationFn: ({ code, codeVerifier }: Params) =>
      api.authControllerAdminImpersonateCodeExchange({
        adminImpersonateCodeExchangeRequest: { code, codeVerifier },
      }),
  });
};
